'use client'

import { DatesProvider } from '@mantine/dates'
import { useLocale } from 'next-intl'
import 'dayjs/locale/de'

interface Props {
    children: React.ReactNode
}

export default function AppDatesProvider({ children }: Props) {
    const locale = useLocale()

    return <DatesProvider settings={{ locale, firstDayOfWeek: 1, weekendDays: [0, 6] }}>{children}</DatesProvider>
}
